import React from 'react';
import ReactTooltip from 'react-tooltip';
import './style.scss';
import language from '@language';

export default class Form extends React.Component<any, any> {
    constructor(props) {
        super(props);
        const { initValues } = this.props;
        this.state = {
            fields: initValues
        };
    }

    handleChange(event) {
        const fieldName = event.target.name;
        const fieldValue = event.target.value;
        const { fields } = this.props;

        let newFields = {
            ...fields,
            [fieldName]: fieldValue
        };

        if (['conditions'].indexOf(fieldName) !== -1) {
            newFields = {
                ...newFields,
                conditions: !fields.conditions
            };
        }

        this.props.onChange(newFields);
    }

    handleFileInput(event) {
        const fieldName = event.target.name;
        const fieldValue = event.target.files[0];
        const { fields } = this.props;

        let newFields = {
            ...fields,
            [fieldName]: fieldValue
        };
        this.props.onChange(newFields);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.onSubmit(this.props.fields);
    }

    render() {
        const { errors, sending, showValidations, errorMessage, banks, fields, currency, hideDocument} = this.props;

        return (
            <div className="bank-transfer">
                {sending && (
                    <div className="overlay">
                        <div className="loader" />
                    </div>
                )}
                {errorMessage && (
                    <div id="error-box" className="error-box">
                        <p>{errorMessage}</p>
                    </div>
                )}
                <div className="warning-box margin-bottom margin-top">
                    <p>
                        <i className="icon fa fa-exclamation-triangle" />
                        {language.important}
                    </p>
                    <p>{language.claim_bank_transfer_disclaimer}</p>
                </div>
                <form
                    id="dd-form"
                    onSubmit={e => this.handleSubmit(e)}
                    className={`${showValidations ? 'sended' : ''}`}
                >
                    <div className="row-input">
                        {/*client_number*/}
                        <div className={`input ${errors['client_number'] ? 'invalid' : ''}`}>
                            <label>{language.client_number}</label>
                            <input
                                name="client_number"
                                type="text"
                                value={fields.client_number}
                                onChange={e => this.handleChange(e)}
                                maxLength={8}
                            />
                            {errors['client_number'] && <div className="error-tooltip">{errors['client_number']}</div>}
                        </div>

                        {/*property_number*/}
                        <div className={`input ${errors['property_name'] ? 'invalid' : ''}`}>
                            <label>{language.property_name}</label>
                            <input name="property_name" type="text" onChange={e => this.handleChange(e)} />
                        </div>
                    </div>

                    <div className="row-input">
                        {/*holder_name*/}
                        <div className={`input ${errors['holder_name'] ? 'invalid' : ''}`}>
                            <label>{language.holder_name}</label>
                            <input
                                value={fields.holder_name}
                                name="holder_name"
                                type="text"
                                onChange={e => this.handleChange(e)}
                            />
                        </div>

                        {/*cuil*/}
                        {!hideDocument && 
                            <div className={`input ${errors['document'] ? 'invalid' : ''}`}>
                                <label>{language.document}</label>
                                <input
                                    value={fields.document}
                                    name="document"
                                    type="text"
                                    onChange={e => this.handleChange(e)}
                                />
                                {errors['document'] && <div className="error-tooltip">{errors['document']}</div>}
                            </div>
                        }
                    </div>

                    <div className="row-input">
                        {/*email*/}
                        <div className={`input ${errors['email'] ? 'invalid' : ''}`}>
                            <label>{language.email}</label>
                            <input
                                value={fields['email']}
                                name="email"
                                type="text"
                                onChange={e => this.handleChange(e)}
                            />
                        </div>
                    </div>

                    <div className="row-input">
                        {/*invoice_number*/}
                        <div className={`input ${errors['invoice_number'] ? 'invalid' : ''}`}>
                            <ReactTooltip id="invoice_number" place="top" type="dark" effect="solid">
                                <span>{language.invoice_disclaimer}</span>
                            </ReactTooltip>
                            <label>
                                <span>
                                    {language.invoice_number} <a className="info" data-tip data-for="invoice_number" />
                                </span>
                            </label>
                            <input
                                value={fields['invoice_number']}
                                name="invoice_number"
                                type="text"
                                onChange={e => this.handleChange(e)}
                                maxLength={109}
                            />

                            {errors['invoice_number'] && (
                                <div className="error-tooltip">{errors['invoice_number']}</div>
                            )}
                        </div>

                        {/*amount*/}
                        <div className={`input ${errors['amount'] ? 'invalid' : ''}`}>
                            <label>{language.amount}</label>

                            <div className="group">
                                {currency && <span className="symbol">{currency}</span>}
                                <input
                                    value={fields['amount']}
                                    className="small"
                                    name="amount"
                                    maxLength={15}
                                    type="text"
                                    onChange={e => this.handleChange(e)}
                                />
                            </div>
                            {errors['amount'] && <div className="error-tooltip">{errors['amount']}</div>}
                        </div>
                    </div>

                    <div className="row-input">
                        <div className={`input ${errors['bank_origin'] ? 'invalid' : ''}`}>
                            <label>
                                <span>{language.bank_origin}</span>
                            </label>
                            <select
                                value={fields['bank_origin']}
                                name="bank_origin"
                                onChange={e => this.handleChange(e)}
                            >
                                <option value="" />
                                {banks.map((bank, key) => (
                                    <option key={key} value={bank.id}>
                                        {bank.name}
                                    </option>
                                ))}
                            </select>
                            {errors['invoice_number'] && <div className="error-tooltip">{errors['bank_origin']}</div>}
                        </div>

                        {/*voucher*/}
                        <div className={`input voucher ${errors['voucher'] ? 'invalid' : ''}`}>
                            <label>{language.voucher}</label>
                            <input
                                className="small"
                                name="voucher"
                                type="file"
                                onChange={e => this.handleFileInput(e)}
                            />
                            {errors['voucher'] && <div className="error-tooltip">{errors['voucher']}</div>}
                        </div>
                    </div>

                    <div className="submit">
                        <button type="submit">{language.send}</button>
                    </div>
                </form>
            </div>
        );
    }
}
